const resource = '/admin/v1/works';

export default $axios => ({
  list({exceptId = null} = {}) {
    return $axios.get(`${resource}?&exceptId=${exceptId}`);
  }
});
